export function formattedExitCategory(prefix, category) {
    if (category == null) {
        return prefix;
    } else {
        return (prefix + ':' + category);
    }
}

export function formattedExitDestination(url, method) {
    if (method == null || method === '') {
        method = 'GET'
    }
    return '[' + method + ']' + url;
}